import ReactSignatureCanvas from 'react-signature-canvas'
import './SignatureInput.scss'
import React, { MouseEvent, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { FieldErrorList } from 'components/FieldErrorList/FieldErrorList'
import { FieldError } from 'common.types'

interface SignatureInputProps {
  onEnd: (encodedImage?: string) => void
  onClear: () => void
  required?: boolean
  name: string
  label: string
  errorList?: FieldError[]
}
export const SignatureInput: React.FC<SignatureInputProps> = ({
  onEnd,
  name,
  label,
  required,
  errorList,
  onClear,
}) => {
  const { t } = useTranslation()
  const sigCanvas = useRef<ReactSignatureCanvas | null>(null)
  const clearCanvas = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    sigCanvas?.current?.clear()
    onClear()
  }
  return (
    <div className="signature-input input-wrapper">
      <div className="signature-input__top">
        <label htmlFor={name} className="signature-input__label">
          {required && (
            <span className="signature-input__label__required-asterisk">*</span>
          )}
          {label}
        </label>
        <button
          className="signature-input__clear-button"
          onClick={(e) => clearCanvas(e)}
          aria-label={t('global.clear')}
        >
          {t('global.clear')}
        </button>
      </div>
      <div className="signature-input__canvas">
        <ReactSignatureCanvas
          ref={sigCanvas}
          penColor="black"
          backgroundColor={'white'}
          onEnd={async () => {
            const dataURL = sigCanvas?.current
              ?.getTrimmedCanvas()
              .toDataURL('image/png')
            const base64String = dataURL?.split(',')[1]
            const img = new Image()
            img.src = `data:image/png;base64,${base64String}`

            img.onload = () => {
              const resizeCanvas = document.createElement('canvas')
              const ctx = resizeCanvas.getContext('2d')
              resizeCanvas.width = 180
              resizeCanvas.height = 60
              ctx?.drawImage(img, 0, 0, 180, 60)
              const imageData = ctx?.getImageData(
                0,
                0,
                resizeCanvas.width,
                resizeCanvas.height,
              )
              const data = imageData?.data
              if (data) {
                for (let i = 0; i < data.length; i += 4) {
                  const red = data[i]
                  const green = data[i + 1]
                  const blue = data[i + 2]

                  if (!(red === 255 && green === 255 && blue === 255)) {
                    data[i] = 0
                    data[i + 1] = 0
                    data[i + 2] = 0
                  }
                  data[i + 3] = 255
                }

                ctx?.putImageData(imageData, 0, 0)
              }

              const resizedDataURL = resizeCanvas.toDataURL('image/png')
              const resizedBase64String = resizedDataURL.split(',')[1]
              onEnd(`data:image/png;base64,${resizedBase64String}`)
              img.onload = null
              img.onerror = null
              img.src = ''
            }

            img.onerror = (err) => {
              console.error('Image loading failed:', err)
              img.onload = null
              img.onerror = null
              img.src = ''
            }
          }}
          canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
        />
      </div>
      <FieldErrorList errorListForField={errorList} />
    </div>
  )
}
